import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { ICancelMeetingRequestPayload } from '@app-store/slices/meetingRequests/cancel'

interface TaskAction extends Action {
    payload: ICancelMeetingRequestPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.meetingRequests.cancel

function* cancelMeetingRequestSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/meeting/meeting-requests/cancel/${payload.requestId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        if (payload?.sagaCB?.onError) payload?.sagaCB?.onError(error)
    }
}

function* cancelMeetingRequestSaga(): any {
    yield takeLatest<TaskAction>(onRequest, cancelMeetingRequestSagaTask)
}

export default cancelMeetingRequestSaga
